import { render, staticRenderFns } from "./lenderDetailsDialog.vue?vue&type=template&id=1c56de4c&"
import script from "./lenderDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./lenderDetailsDialog.vue?vue&type=script&lang=js&"
import style0 from "./lenderDetailsDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports